import { FC, PropsWithChildren } from 'react';

import { DataFetchProvider } from '@betterment/js-runtime';
import { StyleClosetThemeProvider, ThemeName } from '@betterment/style-closet-react';

import { GraphQLProvider } from '../graphql';

export const RetailAppProvider: FC<PropsWithChildren> = ({ children }) => {
  const theme = () => {
    return (document.querySelector<HTMLMetaElement>('meta[name="theme"]')?.content || 'default') as ThemeName;
  };

  return (
    <GraphQLProvider>
      <StyleClosetThemeProvider theme={theme()}>
        <DataFetchProvider>{children}</DataFetchProvider>
      </StyleClosetThemeProvider>
    </GraphQLProvider>
  );
};
